import { array, boolean, date, number, object, string } from "yup";
import {
  endDateAfterStartDate,
  endTimeAfterStartTime,
} from "venuescanner-js/utils/validation/helpers";
import StageId from "./components/StageContainer/StageId";

const valueLabelShape = {
  value: string().required(),
  label: string().required(),
};

const schemas = {
  [StageId.InitialEventDetails]: {
    eventType: object(valueLabelShape),
    location: object(valueLabelShape),
    radiusInMiles: string().required(),
    start_date: date().required(),
    end_date: date().when("start_date", endDateAfterStartDate).required(),
    start_time: string()
      .matches(/\d{2}:\d{2}/)
      .required(),
    end_time: string()
      .matches(/\d{2}:\d{2}/)
      .required()
      .when("start_time", endTimeAfterStartTime),
  },
  [StageId.GuestsAndLayout]: {
    guests: number().required(),
    layout: string().required(),
  },
  [StageId.BudgetAndCorpOrPrivate]: {
    budget: array().required(),
    isCorporate: boolean().required(),
    newsletter: boolean().required(),
    eventDescription: string().required(),
    userCompany: string().when("isCorporate", (isCorporate, schema) =>
      isCorporate ? schema.required() : schema
    ),
  },
  [StageId.UserDetails]: {
    userEmail: string().email().required(),
    userPhone: number().required(),
    isTOSAccepted: boolean().oneOf([true]),
  },
};

export default (stageIds) =>
  stageIds.reduce(
    (sch, stageId) => (schemas[stageId] ? sch.shape(schemas[stageId]) : sch),
    object()
  );
